import React, { FC, memo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Map from "Components/Map";
import { setCurrentStop } from "Containers/Stops";
import { areEqualShallow } from "Utils/areEqual";
import { distanceBetweenPoints } from "Utils/utils";

interface Props {
  mapObj: any;
  locId: any;
}

const MapContainer: FC<Props> = memo(({ mapObj, locId }: Props) => {
  const Dispatch = useDispatch();
  const stops = useSelector((selectors: any) => selectors.stops);
  const currentStop = useSelector(
    (selectors: any) => selectors.currentStop.currentStop
  );

  useEffect(() => {
    const stopNearCurrentPosition = (position) => {
      for (let i = 0; i < stops.length; i += 1) {
        /* the distance between two points should be less than 50 ft = 15.24 meters */
        if (
          distanceBetweenPoints(
            stops[i].realLat,
            stops[i].realLng,
            position?.coords?.latitude,
            position?.coords?.longitude
          ) < 15
        ) {
          Dispatch(setCurrentStop(stops[i].id));
        }
      }
    };

    /* eslint-disable no-unused-expressions */
    navigator?.geolocation?.watchPosition(stopNearCurrentPosition, () => {}, {
      maximumAge: 0,
      timeout: 10000,
      enableHighAccuracy: true,
    });
  }, [mapObj, locId, Dispatch, stops]);

  return <Map currentStop={currentStop} mapObj={mapObj} locId={locId} />;
}, areEqualShallow);

export default MapContainer;
